import rainforest from '../../Assets/Sounds/rainforest.mp3';
import ocean from '../../Assets/Sounds/ocean.mp3';
import thunderstorm from '../../Assets/Sounds/thunderstorm.mp3';
import birds from '../../Assets/Sounds/birds.mp3';
import river from '../../Assets/Sounds/river.mp3';
import wind from '../../Assets/Sounds/wind.mp3';


import Tranquility from '../../Assets/Sounds/Tranquility.mp3'; 
export const wellnessActivities = [
    {
      id: 'nature-sounds',
      title: 'Nature Sounds Therapy',
      icon: '🌿',
      sounds: [
        { name: 'Ocean Waves', emoji: '🌊', file: ocean },
        { name: 'Rainforest', emoji: '🌳', file: rainforest },
        { name: 'Thunderstorm', emoji: '⛈️', file: thunderstorm },
        { name: 'Birds Chirping', emoji: '🐦', file: birds },
        { name: 'River Stream', emoji: '🏞️', file: river },
        { name: 'Wind in Trees', emoji: '🍃', file: wind }
      ]
    },
    {
      id: 'mood-music',
      title: 'Therapeutic Music',
  
      icon: '🎵',
      playlists: [
        { name: 'Tranquility', genre: 'Ambient', file: Tranquility },


      ]
    },
    {
      id: 'color-therapy',
      title: 'Color Therapy Visualization',
    
      icon: '🎨',
      colors: [
        { name: 'Calming Blue', hex: '#4A90E2', effect: 'Reduces anxiety and promotes tranquility' },
        { name: 'Energizing Orange', hex: '#F5A623', effect: 'Boosts creativity and enthusiasm' },
        { name: 'Healing Green', hex: '#7ED321', effect: 'Promotes balance and growth' },
        { name: 'Confident Purple', hex: '#9013FE', effect: 'Enhances self-esteem and intuition' },
        { name: 'Grounding Brown', hex: '#8B4513', effect: 'Provides stability and security' },
        { name: 'Pure White', hex: '#FFFFFF', effect: 'Cleanses negative thoughts' }
      ]
    },
    {
      id: 'breathing-patterns',
      title: 'Advanced Breathing Techniques',

      icon: '🌬️',
      techniques: [
        { name: '4-7-8 Technique', pattern: [4, 7, 8], purpose: 'Deep relaxation and sleep' },
        { name: 'Box Breathing', pattern: [4, 4, 4, 4], purpose: 'Stress relief and focus' },
        { name: 'Energizing Breath', pattern: [3, 1, 6, 1], purpose: 'Increase energy and alertness' },
        { name: 'Calming Breath', pattern: [6, 2, 8, 2], purpose: 'Reduce anxiety and tension' },
        { name: '3-Part Breath', pattern: [5, 0, 5, 0], purpose: 'Full body relaxation' }
      ]
    },
    {
      id: 'emotional-regulation',
      title: 'Emotion Regulation Tools',
   
      icon: '🎭',
      allTools: [
        { name: 'RAIN Technique', steps: ['Recognize the emotion', 'Allow it to be present', 'Investigate with kindness', 'Non-attachment - let it pass'], category: 'Mindfulness' },
        { name: '5-4-3-2-1 Grounding', steps: ['5 things you can see', '4 things you can touch', '3 things you can hear', '2 things you can smell', '1 thing you can taste'], category: 'Grounding' },
        { name: 'Body Scan Meditation', steps: ['Start at your toes', 'Notice sensations without judgment', 'Move slowly up your body', 'End at the top of your head'], category: 'Mindfulness' },
        { name: 'Mindful Breathing', steps: ['Focus on your breath', 'Count each inhale and exhale', 'When mind wanders, return gently', 'Continue for 2-3 minutes'], category: 'Breathing' },
        
        { name: 'Thought Stopping', steps: ['Notice the negative thought', 'Say "STOP" firmly', 'Replace with a positive thought', 'Engage in a different activity'], category: 'Cognitive' },
        { name: 'Cognitive Reframing', steps: ['Identify the negative thought', 'Ask "Is this thought helpful?"', 'Find a more balanced perspective', 'Practice the new thought'], category: 'Cognitive' },
        { name: 'The 3 Cs Technique', steps: ['Catch the negative thought', 'Challenge its accuracy', 'Change it to something realistic', 'Celebrate the progress'], category: 'Cognitive' },
        { name: 'Perspective Taking', steps: ['Step back from the situation', 'Ask "How will this matter in 5 years?"', 'Consider other viewpoints', 'Choose the most helpful perspective'], category: 'Cognitive' },
        
        { name: 'Progressive Muscle Relaxation', steps: ['Tense muscle group for 5 seconds', 'Release suddenly and completely', 'Notice the contrast and relaxation', 'Move to the next muscle group'], category: 'Physical' },
        { name: 'Temperature Technique', steps: ['Hold ice cubes or cold water', 'Focus on the temperature sensation', 'Let it ground you in the present', 'Notice emotions becoming manageable'], category: 'Physical' },
        { name: 'Bilateral Stimulation', steps: ['Cross your arms over your chest', 'Tap alternately with your hands', 'Continue rhythmic tapping', 'Focus on the calming effect'], category: 'Physical' },
        { name: 'Pressure Point Relief', steps: ['Press firmly between thumb and index finger', 'Hold for 30 seconds while breathing deeply', 'Release and notice the sensation', 'Repeat on other hand if needed'], category: 'Physical' },
        
        { name: 'Emotion Wheel Exercise', steps: ['Name the emotion you\'re feeling', 'Rate its intensity 1-10', 'Identify what triggered it', 'Choose how to respond wisely'], category: 'Processing' },
        { name: 'TIPP Technique', steps: ['Change your Temperature (cold water)', 'Do Intense exercise for 10 minutes', 'Use Paced breathing', 'Practice Progressive muscle relaxation'], category: 'Processing' },
        { name: 'Opposite Action', steps: ['Identify what the emotion wants you to do', 'Consider if this action is wise', 'If not, do the opposite action', 'Act with intention, not impulse'], category: 'Processing' },
        { name: 'Self-Compassion Break', steps: ['Acknowledge "This is a moment of suffering"', 'Remember "Suffering is part of life"', 'Place hand on heart', 'Offer yourself kindness'], category: 'Processing' },
        
        { name: 'Emotional Art Expression', steps: ['Choose colors that match your mood', 'Draw or scribble your emotions', 'Don\'t judge the outcome', 'Notice how you feel after expressing'], category: 'Creative' },
        { name: 'Letter Writing Technique', steps: ['Write a letter to your emotion', 'Express what you want to say', 'Thank it for trying to protect you', 'Set boundaries about its influence'], category: 'Creative' },
        { name: 'Story Reframing', steps: ['Tell your situation as a story', 'Imagine you\'re the hero, not victim', 'What would the hero do next?', 'Write the next empowering chapter'], category: 'Creative' },
        { name: 'Emotional Music Therapy', steps: ['Choose music that matches your mood', 'Listen mindfully for 3-5 minutes', 'Let the emotions flow', 'Transition to uplifting music gradually'], category: 'Creative' }
      ]
    }
  ];

 export const mentalHealthQuotes = [
    "Your mental health is a priority. Your happiness is essential. Your self-care is a necessity.",
    "It's okay to not be okay. It's not okay to stay that way.",
    "Healing doesn't mean the damage never existed. It means it no longer controls our lives.",
    "You are stronger than you know, braver than you feel, and more loved than you imagine.",
    "Your current situation is not your final destination.",
    "Progress, not perfection, is the goal."
  ];

 export const personalityTypes = [
    {
      type: 'The Perfectionist',
      traits: ['High standards', 'Detail-oriented', 'Self-critical'],
      mentalHealthTips: [
        'Practice self-compassion when things don\'t go as planned',
        'Set realistic, achievable goals',
        'Learn to celebrate small victories',
        'Practice mindfulness to reduce overthinking'
      ],
      color: 'from-red-400 to-pink-500'
    },
    {
      type: 'The People Pleaser',
      traits: ['Seeks approval', 'Avoids conflict', 'Puts others first'],
      mentalHealthTips: [
        'Practice saying "no" without guilt',
        'Set healthy boundaries in relationships',
        'Focus on your own needs and wants',
        'Learn that it\'s okay to disappoint others sometimes'
      ],
      color: 'from-blue-400 to-indigo-500'
    },
    {
      type: 'The Overthinker',
      traits: ['Analyzes everything', 'Worries about future', 'Dwells on past'],
      mentalHealthTips: [
        'Practice mindfulness and present-moment awareness',
        'Use grounding techniques when overthinking starts',
        'Challenge negative thought patterns',
        'Engage in physical activities to break thought cycles'
      ],
      color: 'from-purple-400 to-violet-500'
    },
    {
      type: 'The High Achiever',
      traits: ['Goal-oriented', 'Competitive', 'Fear of failure'],
      mentalHealthTips: [
        'Remember that your worth isn\'t tied to achievements',
        'Practice self-care even when busy',
        'Learn from failures instead of fearing them',
        'Take breaks to prevent burnout'
      ],
      color: 'from-green-400 to-emerald-500'
    }
  ];

 export const stressReliefGames = [
    {
      name: 'Bubble Pop Meditation',
      description: 'Pop virtual bubbles while focusing on your breathing',
      difficulty: 'Easy',
      duration: '3-5 minutes',
      icon: '🫧'
    },
    {
      name: 'Pattern Drawing',
      description: 'Create repetitive patterns to calm your mind',
      difficulty: 'Medium',
      duration: '10-15 minutes',
      icon: '✏️'
    },
    {
      name: 'Color by Emotions',
      description: 'Color mandalas based on your current emotional state',
      difficulty: 'Easy',
      duration: '15-30 minutes',
      icon: '🌀'
    },
    {
      name: 'Gratitude Garden',
      description: 'Plant virtual flowers by writing things you\'re grateful for',
      difficulty: 'Easy',
      duration: '5-10 minutes',
      icon: '🌻'
    }
  ];




 